import {
    AppModule,
    availableModules,
    IModuleInfo,
    ModuleAction,
} from '@/types/module';

export class ModuleUtils {
    public static findModuleByPath(path: string): AppModule | undefined {
        if (path === '/') {
            return 'home';
        }

        const modules = availableModules
            .filter((x) => {
                return x !== 'home';
            })
            .map(this.getModuleInfo);

        return modules.find((x) => {
            return path.startsWith(x.path);
        })?.module;
    }

    public static getActionName(action: ModuleAction): string {
        switch (action) {
        case 'details':
            return 'Detalles';
        
        case 'export_historic':
            return 'Exportar histórico';
          
        case 'export':
            return 'Exportar';
          
        case 'import':
            return 'Importar';
          
        case 'unify':
            return 'Unificar';
          
        case 'block':
            return 'Bloquear';
          
        case 'change_state':
            return 'Cambiar estado';
          
        case 'more_actions':
            return 'Más acciones';

        case 'update':
            return 'Actualizar';

        case 'delete':
            return 'Eliminar';

        case 'list':
            return 'Listar';

        case 'create':
            return 'Crear';

        case 'disable':
            return 'Deshabilitar';

        case 'enable':
            return 'Habilitar';

        case 'changeStatus':
            return 'Cambiar estado(Agentes)';

        case 'changeStatusAdmin':
            return 'Cambiar estado(Supervisor)';
        case 'detailsAdmin':
            return 'Ver detalles(Supervisor)';
        case 'assignMe':
            return 'Asignarme a mi';
        case 'transferTicket':
            return 'Transferir ticket';
            /*
        case 'chatbotDetails':
            return 'Detalles de chatbots';

        case 'chatbotAdd':
            return 'Agregar chatbot';

        case 'chatbotEdit':
            return 'Editar chatbot';

        case 'chatbotDelete':
            return 'Eliminar chatbot';

        case 'chatbotChangeStatus':
            return 'Cambiar estado de chatbot';
        */
        default: {
            return String(action);
        }
        }
    }

    public static getModuleInfo(module: AppModule): IModuleInfo {
        switch (module) {
        case 'home':
            return {
                label: 'Dashboard',
                path: '/',
                module,
                availableActions: [],
            };

        case 'users':
            return {
                label: 'Lista de Usuarios',
                path: '/users',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'companies':
            return {
                label: 'Empresas',
                path: '/companies',
                module,
                availableActions: ['details'],
            };

        case 'groups':
            return {
                label: 'Grupos de Atención',
                path: '/groups',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'tags':
            return {
                label: 'Etiquetas',
                path: '/tags',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'types':
            return {
                label: 'Tipificaciones',
                path: '/types',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'roles':
            return {
                label: 'Roles y Permisos',
                path: '/roles',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'tickets':
            return {
                label: 'Tickets',
                path: '/tickets/',
                module,
                availableActions: [
                    'create',
                    'details',
                    'delete',
                    'update',
                    'changeStatus',
                    'changeStatusAdmin',
                    'detailsAdmin',
                    'assignMe',
                    'transferTicket',
                    'more_actions'
                ],
            };

        case 'channels':
            return {
                label: 'Canales',
                path: '/channels',
                module,
                availableActions: ['create', 'details', 'delete', 'update', 'change_state'],
            };
          
        case 'contacts':
            return {
                label: 'Contactos',
                path: '/contacts',
                module,
                availableActions: ['create', 'details', 'delete', 'update', 'export', 'import', 'unify', 'block'],
            };

        case 'contacts_groups':
            return {
                label: 'Grupo de Contactos',
                path: '/contacts',
                module,
                availableActions: ['create', 'details', 'delete', 'update', 'export'],
            };
            // case 'bots':
            //     return {
            //         label: 'Asistente IA',
            //         path: '/bots',
            //         module,
            //         availableActions: ['create', 'details', 'delete', 'update'],
            //     };
        case 'reports':
            return {
                label: 'Reportes',
                path: '/reports',
                module,
                availableActions: ['details'],
            };
        case 'customFields':
            return {
                label: 'Campos',
                path: '/customFields',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'templates':
            return {
                label: 'Plantillas',
                path: '/templates',
                module,
                availableActions: ['create', 'details', 'delete', 'update'],
            };

        case 'tools':
            return {
                label: 'Gestor de Tools',
                path: '/tools',
                module,
                availableActions: ['create', 'delete', 'update', 'details'],
            };
        case 'records':
            return {
                label: 'Registro de Costos',
                path: '/records',
                module,
                availableActions: ['create', 'delete', 'update', 'details'],
            };

        case 'ia-tester':
            return {
                label: 'Prueba de Bot',
                path: '/ia-tester',
                module,
                availableActions: [],
            };
        
        case 'users-tracking': 
            return {
                label: 'Seguimiento de Usuarios',
                path: '/users-tracking',
                module,
                availableActions: ['details', 'export_historic', 'changeStatusAdmin'],
            };

        default: {
            return {
                label: `--${module}`,
                path: '/404',
                module,
                availableActions: [],
            };
        }
        }
    }
}
